<template>
    <div class="main">
        <global-tag>
            <span slot="title">社情民意收集</span>
            <div class="search" slot="search">
                <el-form label-width="120px" :model="queryInfo">
                    <div class="searchBox">
                        <div class="content">
                            <el-row>
                                <el-col :span="5">
                                    <el-form-item label="需求标题：">
                                        <el-input
                                            clearable
                                            v-model.trim="queryInfo.title"
                                            style="width: 100%"
                                            placeholder="请输入"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="7">
                                    <el-form-item label="信息采集时间：">
                                        <el-date-picker
                                            type="datetimerange"
                                            value-format="yyyy-MM-dd"
                                            format="yyyy-MM-dd"
                                            range-separator="至"
                                            style="width: 100%"
                                            v-model="queryInfo.recTime"
                                            start-placeholder="开始日期"
                                            end-placeholder="结束日期"
                                            @change="recTimeChange"
                                        >
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="5">
                                    <el-form-item label="处理状态：">
                                        <el-select
                                            style="width: 100%"
                                            v-model="queryInfo.dealStatus"
                                            placeholder="请选择"
                                        >
                                            <el-option
                                                v-for="item in dealList"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="btn">
                            <el-button type="primary" @click="querySearch" class="searchBtns"
                                >查询</el-button
                            >
                        </div>
                    </div>
                </el-form>
            </div>
        </global-tag>
        <div class="table_title">
            <div class="btn_group">
                <el-button
                    type="success"
                    class="openBtns"
                    size="medium"
                    @click="addServices('新增', 'add')"
                    >新增</el-button
                >
                <el-button
                    type="primary"
                    class="downOutBtns"
                    size="medium"
                    @click="createExcel"
                    >导出数据</el-button
                >
                <div style="display: none">
                    <input @change="fileChange" id="speechUpload" type="file" />
                </div>
                <label for="speechUpload" class="labelImportBtn inDwonBtns">
                    <span>导入</span>
                </label>
                <!-- <el-button
                    type="danger"
                    class="button"
                    size="medium"
                    @click="deleteItem"
                    >删除</el-button
                > -->
            </div>
            <!-- 筛选按钮 -->
            <div class="screen_container">
                <el-button-group>
                    <el-button
                        type="primary"
                        icon="el-icon-refresh"
                        class="dropRests"
                        @click="reset"
                    ></el-button>
                    <!-- <el-button type="primary" style="padding: 10px 20px"> -->
                        <el-dropdown trigger="click" :hide-on-click="false" class="dropdown1">
                            <span class="el-dropdown-link">
                                <i
                                    class="el-icon-s-grid el-icon--right"
                                    style="color: #fff"
                                ></i>
                                <i
                                    class="el-icon-arrow-down el-icon--right"
                                ></i>
                            </span>
                            <el-dropdown-menu
                                slot="dropdown"
                                class="table_checkbox"
                            >
                                <el-dropdown-item>
                                    <el-checkbox-group
                                        v-model="tableChekbox"
                                        @change="tableChekboxChange"
                                    >
                                        <el-checkbox label="序号"></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="需求标题"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="需求人姓名"
                                        ></el-checkbox
                                        ><br />

                                        <el-checkbox
                                            label="联系方式"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="需求详情"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="处理状态"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="需求处理反馈描述"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="点位坐标"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="创建人"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="创建时间"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox label="操作"></el-checkbox
                                        ><br />
                                    </el-checkbox-group>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    <!-- </el-button> -->
                </el-button-group>
            </div>
        </div>
        <div class="table_container">
            <el-table
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                height="550px"
                ref="multipleTable"
                :header-cell-style="{
                    background: '#e6e6e6',
                    color: '#000',
                }"
                border
            >
                <!-- <el-table-column type="selection" width="55"> </el-table-column>  @selection-change="handleSelectionChange" -->
                <el-table-column
                    type="index"
                    width="70"
                    label="序号"
                    align="center"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '序号'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="需求标题"
                    align="center"
                    prop="title"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '需求标题'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="需求人名称"
                    align="center"
                    prop="name"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '需求人名称'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="联系方式"
                    align="center"
                    prop="phone"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '联系方式'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="需求详情"
                    align="center"
                    prop="details"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '需求详情'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="处理状态"
                    align="center"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '处理状态'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.dealStatus == 0">未处置</span>
                        <span v-if="scope.row.dealStatus == 1">处置中</span>
                        <span v-if="scope.row.dealStatus == 2">处置未办结</span>
                        <span v-if="scope.row.dealStatus == 3">处置已办结</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="需求处理反馈描述"
                    align="center"
                    prop="result"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '需求处理反馈描述'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="点位坐标"
                    align="center"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '点位坐标'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <div>
                            <span>经度{{ scope.row.longitude }}</span
                            ><span>纬度{{ scope.row.longitude }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    label="创建人"
                    align="center"
                    prop="createPersonName"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '创建人'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="创建时间"
                    align="center"
                    prop="createDate"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '创建时间'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="操作"
                    align="center"
                    width="180px"
                    fixed="right"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '操作'
                        ) != -1
                    "
                >
                    <template slot-scope="scope">
                        <span
                            @click="addServices('编辑', scope.row)"
                            class="operBtn"
                            >编辑</span
                        >
                        <span @click="deleteItem(scope.row)" class="operBtn"
                            >删除</span
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination_container">
            <el-pagination
                :page-size="pageOne.pageSize"
                :current-page.sync="pageOne.pageNo"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageOne.total"
                @size-change="handletableDataSize"
                @current-change="handleTableDataChange"
            ></el-pagination>
        </div>
        <add-service
            v-if="serviceState"
            :openData="serviceInfo"
            @cancleService="cancleService"
        ></add-service>
    </div>
</template>
<script>
import globalTag from "../../components/globalTag"
import addService from "./components/addService"

export default {
    name: "serviceMange",
    inject: ["reload"], //注入
    components: { globalTag, addService },
    data() {
        return {
            pageOne: { total: 0, pageSize: 10, pageNo: 1 },
            dealList: [
                { value: "0", label: "未处置" },
                { value: "1", label: "处置中" },
                { value: "2", label: "处置未办结" },
                { value: "3", label: "处置已办结" },
            ],
            tableData: [],
            queryInfo: {
                dealStatus: "",
                title: "",
                recTime: [],
                bdate: "",
                edate: "",
            },
            serviceState: false,
            serviceInfo: {},

            tempTableChekbox: [
                "序号",
                "需求标题",
                "需求人名称",
                "联系方式",
                "需求详情",
                "处理状态",
                "需求处理反馈描述",
                "点位坐标",
                "创建人",
                "创建时间",
                "操作",
            ],
            tableChekbox: [
                "序号",
                "需求标题",
                "需求人名称",
                "联系方式",
                "需求详情",
                "处理状态",
                "需求处理反馈描述",
                "点位坐标",
                "创建人",
                "创建时间",
                "操作",
            ],
            multipleSelection: [],
        }
    },
    created() {
        this.getList()
    },
    methods: {
        // 选中
        handleSelectionChange(val) {
            // this.multipleSelection = val;
        },
        //服务时间发生变化
        recTimeChange(val) {
            console.log(val)
            if (!val) return
            this.queryInfo.bdate = val[0]
            this.queryInfo.edate = val[1]
        },
        // 当前页
        handleTableDataChange(val) {
            this.pageOne.pageNo = val
            this.getList()
        },
        // 分页大小
        handletableDataSize(val) {
            this.pageOne.pageSize = val
            this.getList()
        },
        // 获取数据
        getList() {
            let params = {
                pageNo: this.pageOne.pageNo,
                pageSize: this.pageOne.pageSize,
                edate: this.queryInfo.edate,
                bdate: this.queryInfo.bdate,
                dealStatus: this.queryInfo.dealStatus,
                title: this.queryInfo.title,
            }
            this.$http
                .request({
                    url: "/ypt/admin/socialOpinion/info/findList",
                    method: "POST",
                    data: params,
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.tableData = []
                            this.pageOne.total = 0
                            return
                        }
                        if (res.content.list.length > 0) {
                            res.content.list.forEach((item) => {
                                item.hasChagned =
                                    Number(item.counts) - Number(item.stock)
                            })
                        }
                        this.tableData = res.content.list
                        this.pageOne.total = res.content.count
                    }
                })
        },
        //删除表格信息
        deleteItem(date) {
            let params = {
                id: date.id,
            }
            this.$confirm("确认永久删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.$http
                    .request({
                        url: "/ypt/admin/socialOpinion/info/deleteById",
                        method: "POST",
                        data: params,
                    })
                    .then((res) => {
                        if (res.code === 200) {
                            this.$message.success(res.message)
                            this.$refs.multipleTable.clearSelection()
                            // this.tableData = [];
                            this.getList()
                        } else {
                            this.$message.error(res.message)
                        }
                    })
            })
        },
        // 选择列的展示方式
        tableChekboxChange(val) {
            this.tempTableChekbox = val.map((item) => item)
        },
        // 取消新增、编辑、查看
        cancleService(state) {
            this.serviceState = false

            if (state == true) {
                this.getList()
            }
        },

        // 新增\编辑\查看
        addServices(title, row) {
            this.serviceState = true

            this.serviceInfo = {}
            this.serviceInfo = {
                title: title,
                id: title == "新增" ? "" : row.id,
                state: true,
            }
        },

        // 页面刷新
        reset() {
            this.reload()
        },
        // 搜索
        querySearch() {
            this.getList()
        },
        //导出excel
        async createExcel() {
            const res = await this.request2({
                url: "/ypt/admin/socialOpinion/info/downloadExcel",
                method: "POST",
                data: {},
                responseType: "blob",
            })
            const blob = new Blob([res], { type: "application/vnd.ms-excel" })
            const fileName = "社情民意收集.xls"
            const linkNode = document.createElement("a")

            linkNode.download = fileName //a标签的download属性规定下载文件的名称
            linkNode.style.display = "none"
            linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
            document.body.appendChild(linkNode)
            linkNode.click() //模拟在按钮上的一次鼠标单击

            URL.revokeObjectURL(linkNode.href) // 释放URL 对象
            document.body.removeChild(linkNode)
        },
        // 导入
        async fileChange(event) {
            console.log(event)
            const file = event.target.files[0]
            console.log(file)
            const personType = "1"
            let config = {
                headers: { "Content-Type": "multipart/form-data" },
            }
            let formData = new FormData()
            formData.append("personType", personType)
            console.log(formData)
            formData.append("file", file)
            let result = await this.$http.post(
                "/ypt/admin/socialOpinion/info/excel",
                formData,
                config
            )
            // 清空文件
            const fileEle = document.getElementById("speechUpload")
            fileEle.value = ""
            if (result.code == 200) {
                this.$message.success(result.message)
                this.getList()
            } else {
                this.$message.warning(result.message)
            }
        },
    },
}
</script>
<style lang="less" scoped>
.searchBox {
    display: flex;
    .content {
        flex: 1;
    }
}
/deep/.table_title {
    margin-top: 15px !important;
}
/deep/.btn_group {
    margin-top: 0px !important;
}
.button {
    margin-bottom: 4px;
}
.labelImportBtn {
    background: orange;
    border-radius: 3px;
    cursor: pointer;
    margin: 0 10px;
    font-size: 12px;
    padding: 4px 24px;
    color: #fff;
    line-height: 28px;
    display: inline-block;
}
.operBtn {
    cursor: pointer;
    margin-left: 10px;
}
</style>